
import { defineComponent } from 'vue'
import axios from 'axios'

export default defineComponent({
  name: 'AddUser',
  data () {
    return {
      name: '',
      username: ''
    }
  },
  methods: {
    onSubmit () {
      // Cancel if either form field is empty
      if (!this.name || !this.username) return

      const newUser = {
        name: this.name,
        username: this.username
      }

      axios.post('https://jsonplaceholder.typicode.com/users', newUser).then((response) => {
        console.log(response)
        if (response.status === 201) {
          // Emitted event updates users list in the App component
          this.$emit('add-user', newUser)

          // Reset the form fields
          this.name = ''
          this.username = ''
        }
      })
    }
  }
})
